// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","279":"component---src-pages-index-jsx","598":"component---src-pages-assets-jsx"}[chunkId] || chunkId) + "-" + {"108":"df6666b1246551d53ee9","223":"5883df0869dc0153df94","279":"7ba931d8c2e46d106ce9","452":"6bbc5783567a7333b965","598":"19a44146354e53477a84"}[chunkId] + ".js";
};